import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AxisFormInputs } from '@connect-services/client/components/modals/create-edit-statistic-modal/create-edit-statistic-modal.component';
import { InputTextComponent } from '@connect-services/src/lib/components/input/text/input-text/input-text.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InputTextComponent, RessourcesModule],
    selector: 'app-statistic-render-option',
    templateUrl: './statistic-render-option.component.html',
})
export class StatisticRenderOptionComponent {
    public readonly axisFormInputs = input.required<AxisFormInputs>();
}
